<template>
<div id="auditoria-informe-main">
  <!--
    <v-card
    flat
    class="mb-4 rounded-lg bkground">
      <v-card-text>
        <v-row >
          <v-col cols="3">
            <span class="text-subtitle-2 primary--text">
                {{getAuditoriaInforme.numeroOficio}}
            </span>
          </v-col>
          <v-col cols="9">
            <span class="text-caption font-weight-light">
              {{getAuditoriaInforme.nombre}}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row
    class="text-h5  base6--text">
      <v-col>
      Observaciones
      </v-col>
    </v-row>
    -->
    <v-card
    color="transparent"
    flat>
      <v-card-text class="pa-0">
        <router-view></router-view>
      </v-card-text>
    </v-card>
</div>
</template>
<script>
import AUDITORIA_INFORME from '@/graphql/querys/administracion/auditorias/auditoriaInforme.gql';

export default {
  name: 'AuditoriaInformeMain',
  apollo: {
    auditoriaInforme: {
      query: AUDITORIA_INFORME,
      variables() {
        return {
          id: this.$route.params.idInforme,
        };
      },
    },
  },
  computed: {
    getAuditoriaInforme() {
      if (!this.auditoriaInforme) return [];
      return this.auditoriaInforme;
    },
  },
};
</script>
